import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import styles from './Modal.scss';
import closeImg from "@baseImg/close.png";

const Modal = ({onClose, backgroundColor, children}) => {

	const onEsc = (event) => {
		if (event.keyCode === 27) {
			onClose();
		}
	};

	useEffect(() => {
		document.addEventListener('keydown', onEsc, false);

		// Lock page scroll while the modal is open by locking ONLY <html> (the real
		// viewport scroller). We must NOT lock <body>: <html> has `overflow-x: clip`
		// (main.scss), which disables body->viewport overflow propagation, so
		// `body { overflow: hidden }` would turn <body> itself into a scroll
		// container. The tabs' position:sticky would then stick to <body> (never
		// scrolled) instead of the viewport, so the docked tabs jump off-screen /
		// docking dies after the modal closes.
		const html = document.documentElement;
		const prevHtml = html.style.overflowY;
		html.style.overflowY = "hidden";

		return () => {
			document.removeEventListener('keydown', onEsc, false);
			html.style.overflowY = prevHtml;
		}
	}, []);

	return (
	  <div className={`${styles.container} ${backgroundColor ? styles[backgroundColor] : ''}`}>
		  <button onClick={(e) => {
			  e.stopPropagation();
			  onClose();
		  }} className={styles.closeButtonHolder}>
			  <img src={closeImg} alt={"Close"}/>
		  </button>

		  {children}
	  </div>
	);
};

Modal.propTypes = {
	onClose: PropTypes.func.isRequired,
	backgroundColor: PropTypes.string,
	children: PropTypes.node.isRequired
};

export default Modal;
